/*
 *
 * RecoveryAttemptsExceededModal
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 17-Oct-2024
*/

import React from 'react'
import PropTypes from 'prop-types'
import formattedMessage from './languageModule'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'
import appEnvRemap from 'Utility/appEnvRemap'
import './RecoveryAttemptsExceededModal.scss'

const RecoveryAttemptsExceededModal = (props) => {
  const redirectToLogin = () => {
    props.actions.doHidePopup()
    window.location.replace(appEnvRemap.REDIRECT_PATH_LOGIN)
  }

  return (
    <Toggle>
      <MerchantModal
        title={formattedMessage.title}
        description={formattedMessage.description}
        primaryButtonLabel={formattedMessage.primaryButtonLabel}
        primaryAction={redirectToLogin}
      />
    </Toggle>
  )
}

RecoveryAttemptsExceededModal.propTypes = {
  actions: PropTypes.object
}

RecoveryAttemptsExceededModal.defaultProps = {
  actions: {}
}

export default RecoveryAttemptsExceededModal
